import { render, staticRenderFns } from "./parcel.vue?vue&type=template&id=6631afe0&scoped=true"
import script from "./parcel.vue?vue&type=script&lang=js"
export * from "./parcel.vue?vue&type=script&lang=js"
import style0 from "./parcel.vue?vue&type=style&index=0&id=6631afe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631afe0",
  null
  
)

export default component.exports